export enum ActionTypes {
    loadCompanyAndBrand = "loadCompanyAndBrand",
    loadCollections = "loadCollections"
}